<template lang="pug">
.container-restricao.row
    .col-8
        small Foram detectadas sobreposições com as seguintes áreas embargadas pelo ICMBIO:

        .list-group
            a.list-group-item.list-group-item-action
                .row
                    label.col-3 ID
                    label.col-3 Área (ha)

            a.list-group-item.list-group-item-action(
                v-for='(restricao, index) in areaEmbargada.restricoes'
            )
                .row
                    .col-3
                        span(
                            data-toggle='tooltip',
                            data-placement='bottom',
                            data-boundary='body'
                        ) {{ restricao.properties.id }}

                    .col-3
                        span {{ getArea(restricao) }}

    .col-4
        mapa(
            v-if='layersMaps',
            :mapLayersConfigs='layersMaps',
            :mapConfig='mapConfig',
            :locked='true',
            :height='"180px"',
            :idMapa='"mapaRestricaoAreaEmbargadaGdf"'
        )
</template>

<script>
import Mapa from '@/components/MapaLeaflet';

import LayerStyle from '@/utils/layerStyles';
import formatters from '@/utils/formatters';

export default {
    name: 'AreaEmbargadaGdf',

    components: {
        Mapa
    },

    data() {
        return {
            layersMaps: null,
            mapConfig: {
                controls: {
                    fullscreen: true
                }
            }
        };
    },
    props: {
        areaEmbargada: {
            type: Object,
            required: true
        },

        geometriaAreaMonitorada: {
            type: Object,
            required: true
        }
    },
    methods: {
        configureLayersMapa() {
            this.layersMaps = [];

            let layerAreaMonitorada = {
                style: LayerStyle.AREA_MONITORADA(),
                name: 'Área Monitorada',
                geoJson: this.geometriaAreaMonitorada
            };

            this.layersMaps.push(layerAreaMonitorada);

            this.areaEmbargada.restricoes.forEach(feature => {
                let layerRestricao = {
                    style: LayerStyle.RESTRICAO(),
                    geoJson: feature.geometry,
                    name: 'Áreas embargadas - GDF',
                    tooltip: `ID: ${feature.properties.id}`
                };

                this.layersMaps.push(layerRestricao);
            });
        },

        getArea(restricao) {
            return formatters.formatNumber(restricao.properties.areaHa, 2);
        }
    },
    mounted() {
        this.configureLayersMapa();
    }
};
</script>
